var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMessageIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 12,
    viewBox: "0 0 15 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9716 1.5695C14.9064 1.13393 14.6874 0.736128 14.3541 0.448192C14.0209 0.160257 13.5955 0.00125122 13.1551 0H1.84409C1.40368 0.00125122 0.978293 0.160257 0.645044 0.448192C0.311794 0.736128 0.0927392 1.13393 0.0275879 1.5695L7.49959 6.4045L14.9716 1.5695Z",
    fill: "#949494"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.7715 7.41969C7.69061 7.47199 7.59633 7.49982 7.5 7.49982C7.40367 7.49982 7.30939 7.47199 7.2285 7.41969L0 2.74269V10.1552C0.000529396 10.6442 0.19503 11.1131 0.540826 11.4589C0.886622 11.8047 1.35547 11.9992 1.8445 11.9997H13.1555C13.6445 11.9992 14.1134 11.8047 14.4592 11.4589C14.805 11.1131 14.9995 10.6442 15 10.1552V2.74219L7.7715 7.41969Z",
    fill: "#949494"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageIcon);
export default __webpack_public_path__ + "static/media/MessageIcon.76375051b44bf318bc57ed8f82e36478.svg";
export { ForwardRef as ReactComponent };